﻿import { defineComponent } from 'vue';
import { useBookingStore } from '../../../store/bookingstore';

import itinerary_breakdown from "../common/itinerary_breakdown.vue"
import trip_summary from "../common/trip_summary.vue"

import { Booking } from "../../../services/booking";
import { Payment } from "../../../services/payment";
import { Date_Service } from "../../../../system/services/date_service";
import { Currency_Service } from "../../../../system/services/currency";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { v1_2_get_booking } from "../../../objects/v1_2/v1_2_get_booking/v1_2_get_booking";
import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";

const Book: Booking = new Booking();
const Payment_Service = new Payment();
const Currency_Services: Currency_Service = new Currency_Service();
const Date_Services: Date_Service = new Date_Service();

class payment_made {
    date_made: string | null = null;
    payment_method: string | null = null;
    payment_status: string | null = null;
    nett_gross: string | null = null;
    amount: number | null = null;
    amount_formatted: string | null = null;
    iso_currency_code: string | null = null;
    status: string | null = null;
}

export default defineComponent({
    name: "summary",
    components: {
        itinerary_breakdown,
        trip_summary
    },
    props: {
    },
    data() {
        return {
            show_breakdown: false,
            show_summary: false
        }
    },
    setup() {
        const bookingStore = useBookingStore();

        return {
            bookingStore
        }
    },
    methods: {
        get_booking(): booking_search_group {
            return this.$store.getters.get_Payment_Session?.get_booking || this.$store.getters.get_Booking;
        },
        GetBrand(): string {
             return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        get_payment_balance_formatted(): string {
            return Currency_Services.Format_Currency(this.get_payment_balance(), this.$store.getters.get_Currency);
        },
        get_payment_balance(): number {
            let payment_session : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            if (!this.is_last_payment_success() && payment_session && payment_session != null && payment_session.payment_initialise.amount != null && payment_session.payment_initialise.amount > 0) {
                return payment_session.payment_initialise.amount;
            }

            return Book.get_total_outstanding_distinct(this.get_booking(), this.isAgent_Login());
        },
        get_payment_fees_formatted(): string {
            return Currency_Services.Format_Currency(this.get_payment_fees(), this.$store.getters.get_Currency);
        },
        get_payment_fees(): number {
            let fees : number = 0;

            if (this.is_last_payment_success()) return fees;
            
            let payment_session : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            if (payment_session && payment_session != null && payment_session.payment_initialise != null && payment_session.payment_initialise.payments != null) {
                 fees = payment_session.payment_initialise.payments.reduce((fees, payment) => fees + (payment.fee || 0), 0);
            }

            return fees;
        },
        get_total_balance_outstanding_formatted(): string {
            return Currency_Services.Format_Currency(this.get_total_balance_outstanding(), this.$store.getters.get_Currency);
        },
        get_total_balance_outstanding(): number {
            return Book.get_total_outstanding_distinct(this.get_booking(), this.isAgent_Login());
        },
        has_balance_outstanding(): boolean {
            return Book.get_total_outstanding_distinct(this.get_booking(), this.isAgent_Login()) > 0;
        },
        Balance_Due_Date(): string {
            return Date_Services.full_date(Book.get_Expiry_Date(this.get_booking()));
        },
        get_Currency(): string {
            return this.$store.getters.get_Currency.currency_info.iso_currency_code;
        },
        get_Total_Price(): string {
            return Currency_Services.Format_Currency(Book.get_total_price(this.get_booking(), this.$store), this.$store.getters.get_Currency);
        },
        get_payment_amount() : number {
            let payment_session = this.$store.getters.get_Payment_Session;
            return payment_session?.payment_initialise.amount ? payment_session?.payment_initialise.amount : this.get_payment_balance();
        },
        redirect_to_paymentpage(amount: number) {
            if (amount == 0) {
                amount = this.get_payment_balance();
            }

            this.$router.push({ path: "/creditcard" });
        },
        reloadPage() {
            window.location.reload();
        },
        isAgent_Login(): boolean {
            let payment_app_id = this.bookingStore.payment_app_id;
            if (payment_app_id != null && payment_app_id != "" && payment_app_id != import.meta.env.VITE_APP_ID) {
                return true;
            }

            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        get_payments() {
            let payments_made: payment_made[] = [];
            let payment_session = this.$store.getters.get_Payment_Session;

            if (import.meta.env.VITE_ENABLE_CONSOLE_LOGGING == "true") {
                console.log("Payment Session: ", payment_session);
            }

            payment_session.get_booking.payments?.forEach((payment: any) => {

                if (this.isAgent_Login() == false && payment.payment_method == "Credit Agreement") return;

                let payment_made_obj: payment_made = new payment_made();
                payment_made_obj.amount = 0;   
                payment_made_obj.date_made = payment.date_made;
                payment_made_obj.payment_method = payment.payment_method;
                payment_made_obj.payment_status = payment.payment_status;
                payment_made_obj.nett_gross = payment.nett_gross;
                payment_made_obj.status = payment.payment_status;
                payment_made_obj.iso_currency_code = payment.iso_currency_code;

                payment.payment_allocations.forEach(payment_allocation => {
                    payment_made_obj.amount = Payment_Service.AddCurrency(payment_made_obj.amount, payment_allocation.amount);
                    payment_made_obj.amount = Payment_Service.AddCurrency(payment_made_obj.amount, payment_allocation.credit_card_fee);
                });

                payment_made_obj.amount_formatted = Currency_Services.Format_Currency(payment_made_obj.amount, this.$store.getters.get_Currency);
                payments_made.push(payment_made_obj);
            });

            return payments_made;
        },
        has_payments(): boolean {
            return this.get_payments()?.length > 0;
        },
        get_total_price_paid_formatted(): string {
            let paid_amount : number = 0;
            this.get_payments().forEach((payment: payment_made) => {
                if (payment.amount != null && payment.amount > 0 && payment.status != null && payment.status.toLowerCase() == "authorised") {
                    paid_amount += payment.amount;
                }
            });

            return Currency_Services.Format_Currency(paid_amount, this.$store.getters.get_Currency);
        },
        get_Departure_Date(): string {
            return Date_Services.output_date(this.get_booking()?.trips[0].departure_date);
        },
        get_tourIds(): string {
            const booking = this.get_booking();
            if (!booking || !Array.isArray(booking.trips)) {
            return "";
            }
            let tourIds = booking.trips
            .filter((trip: any) => trip && trip.tour_id)
            .map((trip: any) => trip.tour_id)
            .join(",");

            //META PIXEL CONDITIONS
            // This should be removed once the new system dashboard is created
            let winterTourIds = ["I3B", "ABE", "X5P", "3H1", "H52"];
            if (winterTourIds.some(id => tourIds.toUpperCase().includes(id))) {
                tourIds += ",WINTER_TOUR_PURCHASE";
            }

            let dateSpecificWinterTourIds = ["IV6", "HXN", "IV5", "OT1", "HXF"];
            const hasDateSpecificWinterTour = dateSpecificWinterTourIds.some(id => tourIds.toUpperCase().includes(id));
            if (hasDateSpecificWinterTour) {
                const departureDateStr = this.get_Departure_Date?.() ?? "";

                const parseYMD = (str: string): Date | null => {
                    const m = /^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})$/.exec(str.trim());
                    if (!m) return null;
                    const y = Number(m[1]);
                    const mo = Number(m[2]) - 1;
                    const d = Number(m[3]);
                    const dt = new Date(y, mo, d);
                    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) return null;
                    return dt;
                };

                const departureDate = departureDateStr ? parseYMD(departureDateStr) : null;

                if (departureDate) {
                    const month = departureDate.getMonth();
                    const isWinterWindow = month === 10 || month === 11 || month === 0 || month === 1 || month === 2;
                    if (isWinterWindow) {
                        tourIds += ",WINTER_TOUR_PURCHASE";
                    }
                }
            }

            
            return tourIds;
        },
        redirect_with_tourIds() {
            const tourIds = this.get_tourIds();
            const currentPath = this.$route.path;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    ...(tourIds ? { tours: tourIds } : {})
                }
            });
        },
        Get_Paid(): number {
            return Book.get_Paid(this.get_booking());
        },
        is_fully_paid(): boolean {
            return !this.has_balance_outstanding();
        },
        is_part_paid(): boolean {
            return this.Get_Paid() > 0 && this.has_balance_outstanding();
        },
        is_not_paid(): boolean {
            return this.Get_Paid() === 0 && this.has_balance_outstanding();
        },
        is_last_payment_success (): boolean {
            let payment_initialise_amount : number = 0;
            let last_payment_amount : number = 0;
            let last_payment_status_success : boolean = false;

            let payment_session = this.$store.getters.get_Payment_Session;
            let payments = this.get_payments();

            payment_initialise_amount = payment_session?.payment_initialise?.amount || 0;
            if (payments.length > 0) {
                last_payment_amount = payments[payments.length-1].amount || 0;
                last_payment_status_success = payments[payments.length-1].payment_status === 'Authorised' || payments[payments.length-1].payment_status === 'Success';
            }

            if ((last_payment_amount > 0 && payment_initialise_amount > 0 && last_payment_amount == payment_initialise_amount) || this.get_total_balance_outstanding() == 0) {
                return true;
            }    

            return false;
        }
    },
    mounted() {
        this.redirect_with_tourIds();
    }
})